module.exports = __webpack_public_path__ + "img/Illustration-rejected.d505ebe6.png";